import { render } from "./LocalizationConfiguration.vue?vue&type=template&id=30fbb82a"
import script from "./LocalizationConfiguration.vue?vue&type=script&lang=js"
export * from "./LocalizationConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__